import React, { Component } from "react";
import {getFavoriteAuthor,removeFavoriteAuthor,addFavoriteAuthor,authorslist} from '../config/Variables';
import {baseurl} from '../config/Settings';

import FetchUserpopup from '../components/FetchUserpopup';
import FetchOwnUserPopup from '../components/FetchOwnUserPopup';




export default class FetchOwnUser extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      runscr:'initial',
      sectionslist:[],
      messagelog: '',
      loading: true,
      users: [],
      numberstid: [],
      error: null
    }
    this.Removetid = this.Removetid.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
   
  }

   handleChecknow = (evnt) => {

   this.state.runscr="refresh";
   this.getFetchUsersdrupal(evnt);

  }

  async Removetid(event) {

    const target = event.target;
      var value = target.value;
     event.target.checked=true;
        if (localStorage.getItem('user-info')) {
          const tid = value
           var index = target.key;

  
          let item = { tid };
          let user = JSON.parse(localStorage.getItem('user-info'))
          let result =  await fetch(removeFavoriteAuthor, {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Accept": 'application/json',
              "Authorization": "Bearer " + user.token.access_token,
            },
            body: JSON.stringify(item)
          });
          result = await result.json();
    
          if (result.message.code == '200') {
             this.state.users= this.state.users.filter(user => {
                  return user.tid !== value ;
                });
            

this.state.users.splice(value, 1);
this.setState({users:this.state.users,runscr:"notrefresh"}); 
      //      this.props.fetchuserpopupcallback(tid);

              
             
    //         this.props.samirCallback(this.state.users.length);
  
          }
        }
       // this.state.hobbies.splice(value, 1);
      
    }
  handleInputChange(event) {

    const target = event.target;
    var value = target.value;
    if (target.checked) {
      this.state.hobbies.push(value);
     // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    } else {
      this.state.users.splice(value, 1);
     // console.log();
    // this.state.hobbies= this.state.hobbies.filter(a => a !== value);
      const index = this.state.hobbies.indexOf(value);
  
      
      if (index > -1) {
        this.state.hobbies.splice(index, 1);
   
        this.state.hobbies.splice(index, 1)
        const x = this.state.hobbies.indexOf(value);
 
        if (this.state.hobbies.indexOf(value) > -1) {
          this.state.hobbies.splice(index, 1);
    
         } // 2nd parameter means remove one item only
      }



     // this.state.hobbies.splice(value, 1);
    }
  }
 
  getFetchUsers() {
    this.state.users=[];
var sectionstring='';
let user = JSON.parse(localStorage.getItem('user-info'))
     let dattg = fetch(getFavoriteAuthor, {
       method: 'POST',
       headers: {
         "Content-Type": "application/json",
         "Accept": 'application/json',
         "Authorization": "Bearer " + user.token.access_token,
       },
       body: JSON.stringify(this.state)
     }).then(response => response.json())
       .then(data => {
         data.data.map(({ tid }, index2) => {
          sectionstring =tid + '+' + sectionstring ;
           this.state.sectionslist.push(tid);
         });
         var ss=this.state.sectionslist.join('+');
         this.getFetchUsersdrupal(this.state.sectionslist);
       });
  }

   getFetchUsersdrupal(parametersvalue){
    var ss = parametersvalue.join('+');
    if(ss ===""){
      ss="none";
    }
  
      fetch(authorslist+ss).then(res => res.json()).then(result => this.setState({
        loading: false,
        users: result
      })).catch(console.log);
  
  }

 

  componentDidMount() {
    this.getFetchUsers();
  }

  render() {
    const {
      users,
      error,
      loading,
      runscr
    } = this.state;
   
    
    if(users.length > 10 ){
      //this.props.samirCallback(users.length);
    }
    if(loading){

      return (
<div className="loading-mypage"> {loading ?<img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?ss" />: ""}</div>
      );

    }else{
      if(this.state.loading ==false && runscr=="initial"){
        var script = document.createElement('script'); script.type = 'text/javascript'; script.src = 'https://aawsat.com/themes/custom/aawsatv3/assets-react/js/custom_js.js?ssssssss'; document.head.appendChild(script);
      }
    return (
      <>
       <div class="authors-list list-scroll"> 
              <div className="add-more big round modal-toggle show-for-large" data-id="modal-author">
                <i className="icomoon-icon icon-plus-green"></i>
              </div>
              <React.Fragment>
                {
                  users.map(({ name, tid, field_opinion_writer_photo }, index) => {
                if(index <11 ){
                      return (
                        <div className="author-option" id={`author-${tid}`} key={index}>
                          <label for={`custom-ownuser-checkbox-${index}`} className="multi-check">
                            <input type="checkbox" id={`custom-ownuser-checkbox-${index}`}
                              name="hobbies" defaultChecked={true} 
                              className="form-check"  defaultValue={`${tid}`} onTouchEnd={this.Removetid} onClick={this.Removetid} />
                            <div className="author-img round">
                              <img src={field_opinion_writer_photo.includes("s3/")?"https://static.srpcdigital.com/styles/large/public/2022-06/Logo-Asharq-07062022.jpg?itok=Z47SDY13":field_opinion_writer_photo} alt="author" />
                            </div>
                            <div className="author-meta">
                              <div className="author-name">{name}</div>
                            </div>
                          </label>
                        </div>
                      );
                      }
                  })
                }
              </React.Fragment>
              
              {users.length > 10 ?  <div className="modal-toggle see-more-link primary margin-horizontal-1 margin-bottom-3" data-id="modal-author-checked">
                          {users.length > 10 ? `اعرض الكل(${users.length})` : ""}
                        </div> : ""}
              </div>
              <div className="add-more big round modal-toggle hide-for-large" data-id="modal-author">
                        <i className="icomoon-icon icon-plus-green"></i>  <span className="hide-for-large">تابع المزيد من الكتاب</span>
                      </div>
                      <FetchUserpopup  userslist={users} fetchownusercallback={this.handleChecknow}  />
                      {users.length  > 10 ? <FetchOwnUserPopup userslist={users}   fetchownusercallback={this.handleChecknow} /> : "" }
             </>
                                                        
              
    );
  
}}
}
